import gsap from 'gsap';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);

export { gsap, ScrollTrigger };

export const prefersReducedMotion = () =>
  typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export const nf = new Intl.NumberFormat('en-US');

/** Tween a number and report rounded values (used by ROI and counters). */
export function tweenNumber(from: number, to: number, onUpdate: (v: number) => void, duration = 0.6, ease = 'power2.out') {
  if (prefersReducedMotion() || from === to) {
    onUpdate(to);
    return () => {};
  }
  const o = { v: from };
  const tw = gsap.to(o, { v: to, duration, ease, onUpdate: () => onUpdate(o.v) });
  return () => tw.kill();
}
